import * as React from "react";
import { forwardRef } from "react";
const SvgTerminal = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-terminal-icon lucide-terminal", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 19h8" }), /* @__PURE__ */ React.createElement("path", { d: "m4 17 6-6-6-6" }));
const ForwardRef = forwardRef(SvgTerminal);
export default ForwardRef;
